import { createContext, useContext } from "react";

// Which app the shared 13-gate journey components are serving: its API prefix, routes and wording.
export const SPACES = {
  quantum: { key: "quantum", api: "/quantum", base: "/quantum", gate: (g) => `/quantum/gate/${g}`, layer: "Quantum layer", weeks: false },
  gates: { key: "gates", api: "/gates13", base: "/app", gate: (g) => `/app/gate/${g}`, layer: "13 Gates to Ecstasy", weeks: true },
};

export const SpaceContext = createContext(SPACES.quantum);
export const useSpace = () => useContext(SpaceContext);
